import React from 'react'
import Markdown from 'react-markdown'

import BoxProgress from './BoxProgress'
import { useI18N } from '../../../libraries/i18n/hook'
import CheckIcon from '../../../assets/icons/checked.svg?react'
import UncheckedIcon from '../../../assets/icons/unchecked.svg?react'
import InfoIcon from '../../../assets/icons/info.svg?react'
import Translate from '../../../libraries/i18n/Translate'

type Props = {
  evaluation: {
    decision: boolean
    feedback: string
  }
  topic: string
}
const ResultBox: React.FC<Props> = ({ evaluation, topic }) => {
  const { t } = useI18N()

  const cleanFeedback = (feedback: string) => {
  // Remove numbering from the feedback since it gets rendered as a list with its own
  // css implications
  return feedback.replace(/^\d\.\s/gm, '')
}

  return (
    <div className='max-w-4xl mx-auto'>
      <BoxProgress progress={100}>
        <>
          <h2 className='my-8 text-center'>{t('interviewer.ai.completed')}</h2>
          <div className='mb-10 text-center'>
            <InterviewResultLabel decision={evaluation.decision} />
          </div>
          <div className='mb-6'>
            <Markdown className='whitespace-pre-wrap list-none'>
              {cleanFeedback(evaluation.feedback)}
            </Markdown>
          </div>
          <ResultDisclaimer topic={topic} />
        </>
      </BoxProgress>
    </div>
  )
}

type ResultDisclaimerProps = { topic: string }
const ResultDisclaimer: React.FC<ResultDisclaimerProps> = ({ topic }) => {
  if (topic !== 'data-science') { return null }
  return (
    <div className='mt-8 bg-yellow-50 text-black p-6 rounded-lg text-sm flex gap-x-4'>
      <InfoIcon className='h-6 stroke-deep-green' />
      {topic === 'data-science' && (
        <div>
          <Translate
            i18nKey='interviewer.ai.dataScience.result.disclaimer'
            components={{
              intro: <div />,
              b: <b />,
              list: <ul className='list-disc pl-4 md:pl-5' />,
              item: <li />,
            }}
          />
        </div>
      )}
    </div>
  )
}

type InterviewResultLabelProps = { decision: boolean }
const InterviewResultLabel: React.FC<InterviewResultLabelProps> = ({ decision }) => {
  const { t } = useI18N()
  const resultLabel = decision ? t('interviewer.ai.passed') : t('interviewer.ai.failed')
  const className = decision ? 'bg-deep-green text-white ' : 'bg-yellow-50 text-black'
  const icon = decision ? <CheckIcon stroke='white' /> : <UncheckedIcon stroke='black' />
  return (
    <div className={`inline-flex items-center gap-x-2 text-center px-4 py-2 rounded-lg ${className}`}>
      {icon} {t('interviewer.ai.result')}: {resultLabel}
    </div>
  )
}

export default ResultBox
